import { CommonModule } from "@angular/common";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { IonicPageModule, IonicModule } from "ionic-angular";
import { ActPaymentRequestComponent } from "./act-payment-request";

@NgModule({
  declarations: [ActPaymentRequestComponent],
  imports: [
    IonicPageModule.forChild(ActPaymentRequestComponent),
    IonicModule,
    CommonModule
  ],
  exports: [ActPaymentRequestComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ActPaymentRequestModule {}



// WEBPACK FOOTER //
// ./src/components/act-payment-request/act-payment-request.module.ts